<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            v-if="exibirDevolucao"
            id="valorFaturamentoCliente"
            class="text-center"
          >
            {{ valorDevolvido }}
          </div>
          <div
            v-if="exibirDevolucao"
            id="valorFaturamentoClienteAnterior"
            class="text-center"
          >
            {{ valorDevovidoAnterior }}
          </div>
          <div
            class="text-center"
          >
            <dashboard-porcentagem-devolucao-clientes />
          </div>
          <div
            class="text-center"
          >
            <dashboard-evolucao-devolucao-clientes />
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import Clientes from '../../../../../../services/somentecliente'
  import eventEmit from '../../../core/EventoEmit'

  export default {
    name: 'ShowExtratoClientesFaturados',
    emits: ['setDadosDevolucaoCliente', 'setDadosHistoricoDevolucaoCliente'],
    components: {
      DashboardPorcentagemDevolucaoClientes: () => import('../../../../graficos/SomenteClientes/ExtratoCliente/ClientesPorcentagemDevolucao'),
      DashboardEvolucaoDevolucaoClientes: () => import('../../../../graficos/SomenteClientes/ExtratoCliente/ClientesEvolucaoDevolucaoAnual'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedores: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receita: [],
      segmento: [],
      selectCliente: JSON.parse(localStorage.clienteSelect),
      exibirDevolucao: false,
      valorDevolvido: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevovidoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    }),

    created () {
      eventEmit.$on('set-comparativo-evolucao-cliente', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-comparativo-evolucao-cliente', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, ultimoDia, select, selectCliente, vendedores, area, rede, supervisor, receita, segmento) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = ultimoDia
        this.select = select
        this.selectCliente = selectCliente
        this.vendedores = vendedores
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento

        this.showDadosDevolucaoCliente()
      },

      async showDadosDevolucaoCliente () {
        this.loading = true
        this.exibirDevolucao = false

        await Clientes.showExtratoClientesDevolucao(this.primeiroDia, this.ultimoDia, this.select, this.selectCliente, this.vendedores, localStorage.tokencontrato, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento).then(resposta => {
          if (resposta.data.status) {
            this.valorDevolvido = resposta.data.valorDevolvido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorDevovidoAnterior = resposta.data.valorDevovidoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            eventEmit.$emit('set-dados-devolucao-cliente', resposta.data.porcentagem, resposta.data.porcentagemRestante)

            eventEmit.$emit('set-dados-historico-devolucao-cliente', resposta.data.labels, resposta.data.valorExibicao)
          } else if (resposta.data.msg === 'Não há dados de devolução no período filtrado') {
            this.valorDevolvido = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorDevovidoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          this.exibirDevolucao = true
        })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
